import * as React from "react";
import { graphql } from "gatsby";
import Container from "react-bootstrap/Container";
import ParagraphAnchorLink from "../../common/ParagraphAnchorLink/ParagraphAnchorLink";
import { IParagraphPhotoGalleryProps } from "./ParagraphPhotoGalleryProps";
import PhotosGallery from "../../common/PhotosGallery/PhotosGallery";

const buildGallery = (node) => {
  const media = node.relationships.field_media;
  const alts = media ? media.field_media_image_1 : [];
  const gallery = media
    ? media.relationships.field_media_image_1.map((x, i) => {
        return {
          url: x.publicUrl,
          alt: alts[i].alt,
          gatsbyImage: x.gatsbyImage,
        };
      })
    : [];
  return gallery;
};

const ParagraphPhotoGallery: React.FC<IParagraphPhotoGalleryProps> = (
  props
) => {
  const { node, color, imgCountPerRow } = props;
  const title = node ? node.field_title : "";
  const subTitle = node ? node.field_subtitle : "";
  const gallery = buildGallery(node);

  if (gallery.length > 1) {
    return (
      <Container fluid="sm" className="pt-3 pb-3 pt-lg-5 pb-lg-5">
        <ParagraphAnchorLink id={node.id} />
        <PhotosGallery
          photos={gallery}
          imgCountPerRow={imgCountPerRow}
          color={color}
          title={title}
          subtitle={subTitle}
          newCarousel={true}
        />
      </Container>
    );
  }
  return null;
};

export const fragment = graphql`
  fragment ParagraphPhotoGallery on paragraph__photo_gallery {
    id
    name
    field_subtitle
    field_title
    relationships {
      field_sites {
        machine_name
      }
      field_media {
        field_media_image_1 {
          alt
        }
        relationships {
          field_media_image_1 {
            publicUrl
            gatsbyImage(
              width: 800
              height: 600
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
          thumbNailSize: field_media_image_1 {
            publicUrl
            gatsbyImage(width: 800, placeholder: BLURRED, formats: [AUTO, WEBP])
          }
        }
      }
    }
  }
`;

export default ParagraphPhotoGallery;
